const DYTE_MEETING_LINK = 'https://app.dyte.io/v2/meeting';

export const buildDyteURL = dyteAuthToken => {
  return `${DYTE_MEETING_LINK}?authToken=${dyteAuthToken}&showSetupScreen=true&disableVideoBackground=true`;
};

export const buildJitsiURL = (meetingUrl, displayName = '') => {
  if (!meetingUrl) return '';
  const params = new URLSearchParams();
  if (displayName) params.set('userInfo.displayName', displayName);
  const qs = params.toString();
  return qs ? `${meetingUrl}#${qs}` : meetingUrl;
};
